export default {
  // 页面标题
  'adsMccAccount.title': 'MCC账户设置',

  // 搜索字段
  'adsMccAccount.platform': '广告平台',
  'adsMccAccount.mccName': 'MCC名称',

  // 按钮
  'adsMccAccount.search': '查询',
  'adsMccAccount.reset': '重置',
  'adsMccAccount.add': '新增',
  'adsMccAccount.delete': '删除',

  // 表格列
  'adsMccAccount.serial': '序号',
  'adsMccAccount.platform': '广告平台',
  'adsMccAccount.mccName': 'MCC名称',
  'adsMccAccount.apiToken': 'API开发者令牌',
  'adsMccAccount.clientId': 'OAuth Client ID',
  'adsMccAccount.clientSecret': 'OAuth Client Secret',
  'adsMccAccount.refreshToken': 'Refresh Token',
  'adsMccAccount.authStatus': '授权状态',
  'adsMccAccount.action': '操作',

  // 授权状态
  'adsMccAccount.authorized': '已授权',
  'adsMccAccount.unauthorized': '未授权',

  // 表单验证
  'adsMccAccount.platformRequired': '请选择广告平台',
  'adsMccAccount.mccNameRequired': '请输入MCC名称',
  'adsMccAccount.apiTokenRequired': '请输入API开发者令牌',
  'adsMccAccount.clientIdRequired': '请输入OAuth Client ID',
  'adsMccAccount.clientSecretRequired': '请输入OAuth Client Secret',
  'adsMccAccount.refreshTokenRequired': '请输入Refresh Token',

  // 表单占位符
  'adsMccAccount.mccNamePlaceholder': '自定义MCC名称',
  'adsMccAccount.apiTokenRequired': '请输入API开发者令牌',
  'adsMccAccount.clientIdRequired': '请输入OAuth Client ID',
  'adsMccAccount.clientSecretRequired': '请输入OAuth Client Secret',
  'adsMccAccount.refreshTokenPlaceholder': '请点击下方按钮获取',
  'adsMccAccount.getRefreshToken': '获取刷新令牌',
  'adsMccAccount.getRefreshTokenInfo': '正在获取刷新令牌...',
  'adsMccAccount.validationError': '请填写所有必填字段',
  'adsMccAccount.save': '保存',
  'adsMccAccount.cancel': '取消',
  'adsMccAccount.fetchDataFailed': '获取数据失败',
  'adsMccAccount.fetchTypesFailed': '获取广告平台类型失败',
  'adsMccAccount.noData': '暂无数据',

  // 弹窗标题
  'adsMccAccount.addMccAccount': '新增MCC账号',

  // 消息提示
  'adsMccAccount.addSuccess': '新增成功',
  'adsMccAccount.addFailed': '新增失败',
  'adsMccAccount.deleteSuccess': '删除成功',
  'adsMccAccount.deleteFailed': '删除失败',
  'adsMccAccount.confirmDelete': '确认删除此条记录吗？',

  // 分页
  'adsMccAccount.totalRecords': '共 {total} 条记录',
  'adsMccAccount.pagination': '第 {current} 页，共 {page} 页，总计 {total} 条记录',
};
